import { Avatar, Box, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
// project import
import { BriefcaseIcon, TriangleWarningIcon } from 'assets/icons/common';
import { dateHandler } from 'pages/globals/global';

function ReminderContent({ reminderList = [], clickHandler }) {
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			{reminderList
				?.sort((a, b) => b?.data?.creationTime?.localDateTimeLong - a?.data?.creationTime?.localDateTimeLong)
				?.map((value, index) =>
					value?.type?.toLowerCase() === 'urgent_case' ? (
						<ListItemButton
							key={index}
							sx={{
								bgcolor: '#F9FAFB',
								borderRadius: '14px',
								px: 1.5,
								py: 1.25,
								mb: '12px',
								'&:hover': { bgcolor: '#F3F4F6' },
							}}
							onClick={() => clickHandler(value?.data)}
						>
							<ListItemAvatar>
								<Avatar
									alt="urgent"
									sx={{
										bgcolor: '#FEE2E2',
										p: '6px',
										width: 40,
										height: 40,
										borderRadius: '50%',
										border: 'none',
									}}
								>
									<TriangleWarningIcon width="16px" height="16px" />
								</Avatar>
							</ListItemAvatar>
							<ListItemText
								primary={
									<Typography sx={{ color: '#334155', fontSize: '0.98rem' }}>
										An{' '}
										<Typography component="span" variant="subtitle1" sx={{ color: '#EF4444' }}>
											urgent
										</Typography>{' '}
										case no{' '}
										<Typography component="span" variant="subtitle1" sx={{ color: '#334155', fontWeight: 500 }}>
											{value?.data?.lynUniqueId}{' '}
										</Typography>
										is pending for your action
									</Typography>
								}
								secondary={
									<Typography sx={{ color: '#64748B', fontSize: '0.95rem', mt: 0.25 }}>
										{dateHandler(value?.data?.creationTime)}
									</Typography>
								}
							/>
						</ListItemButton>
					) : (
						<ListItemButton
							key={index}
							sx={{
								bgcolor: '#F9FAFB',
								borderRadius: '14px',
								px: 1.5,
								py: 1.25,
								mb: '12px',
								'&:hover': { bgcolor: '#F3F4F6' },
							}}
							onClick={() => {
								// console.log("Do nothing");
							}}
						>
							<ListItemAvatar>
								<Avatar
									alt="briefcase"
									sx={{
										bgcolor: '#DBEAFE',
										p: '8px',
										width: 40,
										height: 40,
										borderRadius: '50%',
										border: 'none',
									}}
								>
									<BriefcaseIcon width="16px" height="16px" />
								</Avatar>
							</ListItemAvatar>
							<ListItemText
								primary={
									<Typography sx={{ color: '#334155', fontSize: '0.98rem' }}>
										<Typography component="span" variant="subtitle1" sx={{ color: '#1E293B', fontWeight: 500 }}>
											{value?.data?.positionName}{' '}
										</Typography>{' '}
										is vacant{' '}
										<Typography component="span" variant="subtitle1" sx={{ color: '#334155', fontWeight: 500 }}>
											{value?.lynUniqueId}{' '}
										</Typography>
										now
									</Typography>
								}
								secondary={
									<Typography sx={{ color: '#64748B', fontSize: '0.95rem', mt: 0.25 }}>
										{dateHandler(value?.data?.creationTime)}
									</Typography>
								}
							/>
						</ListItemButton>
					)
				)}
		</Box>
	);
}

export default ReminderContent;

// const avatarImage = require.context("assets/images/icons", true);
// const UserAvatar = ({ user }) => {
//   let profileData = {};

//   if (user.base64 && user.avatar && user.avatar.length > 5) {
//     profileData = JSON.parse(user.avatar)[0];
//   }

//   return user.base64 && user.avatar && profileData?.thumbUrl ? <Avatar alt={user.name} src={profileData.thumbUrl} size="sm" /> : <Avatar alt={user.name} src={avatarImage("./user.png")} size="sm" />;
// };
